module.exports = __webpack_public_path__ + "static/media/bg5.4dc81b9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/minibg/bg5.jpg
// module id = 804
// module chunks = 0